import { render } from "./AddNewProjectModal.vue?vue&type=template&id=50348304&scoped=true"
import script from "./AddNewProjectModal.vue?vue&type=script&lang=js"
export * from "./AddNewProjectModal.vue?vue&type=script&lang=js"

import "./AddNewProjectModal.vue?vue&type=style&index=0&id=50348304&lang=scss&scoped=true"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50348304"]])

export default __exports__